import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
// import { getHomePageUrl, getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors"; //Husky Custom Code
import LinksState from "@insite/client-framework/Store/Links/LinksState";
import translate from "@insite/client-framework/Translate";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
// import Breadcrumbs, { BreadcrumbsPresentationProps } from "@insite/mobius/Breadcrumbs"; //Husky Custom Code
import { LinkProps } from "@insite/mobius/Link";
import React from "react";
import { connect } from "react-redux";

/* Husky Custom Code - Start */
import House from "@husky-hrc/Components/Icons/House";
import Breadcrumbs, { BreadcrumbsPresentationProps } from "@husky-hrc/MobiusOverrides/Breadcrumbs/Breadcrumbs";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasLinksState } from "@insite/client-framework/Store/Links/LinksState";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, resolveColor, safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { FC, useMemo } from "react";
import { css } from "styled-components";
/* Husky Custom Code - End */

interface OwnProps {
    extendedStyles?: PageBreadcrumbsStyles;
}

/* Husky Custom Code - Start */
const getHomePageUrl = (state: HasLinksState) => {
    return getPageLinkByPageType(state, "HomePage")?.url ?? "/";
};
/* Husky Custom Code - End */

const mapStateToProps = (state: ApplicationState) => {
    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        homePageUrl: getHomePageUrl(state),
    };
};

export interface PageBreadcrumbsStyles {
    breadcrumbs?: BreadcrumbsPresentationProps;
}

/* Husky Custom Code - Start */
const iconCss = (firstIcon = false) => css`
    color: ${getColor("secondary.main")};
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                css`
                    color: ${resolveColor("secondary.main", theme)};
                    margin: ${firstIcon ? `0 0.5em 0 0` : `0 0.5em`};
                `,
                null,
                null,
                css`
                    display: none;
                `,
            ],
            "min",
        )}
`;
/* Husky Custom Code - End */

/* Husky Custom Code - Start */
export const pageBreadcrumbStyles: PageBreadcrumbsStyles = {
    breadcrumbs: {
        mergeCss: true,
        typographyProps: {
            color: "secondary",
            variant: "p",
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                font-size: 14px;
                                font-weight: 700;
                                position: relative;
                                top: -2px;
                                color: ${resolveColor("text.disabled", theme)} !important;
                                &:hover {
                                    color: ${resolveColor("common.accentContrast", theme)} !important;
                                    text-decoration: underline;
                                }
                            `,
                        ],
                        "min",
                    )}
            `,
        },
        slashIconProps: {
            css: css`
                ${iconCss()}
            `,
        },
        firstSlashIconProps: {
            css: css`
                ${iconCss(true)}
            `,
        },
        homeTypographyProps: {
            color: "secondary",
            variant: "p",
            mergeCss: true,
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                display: none;
                            `,
                        ],
                        "min",
                    )}
            `,
        },
        homeSlashTypographyProps: {
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                display: none;
                            `,
                        ],
                        "min",
                    )}
            `,
        },
        lastTypographyProps: {
            color: "secondary",
            variant: "p",
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                font-weight: 800;
                                color: ${resolveColor("common.accentContrast", theme)};
                            `,
                            null,
                            null,
                            css`
                                font-size: 14px;
                                position: relative;
                                text-transform: uppercase;
                                font-weight: 800;
                                background: ${resolveColor("primary.main", theme)};
                                padding: 5px 12px;
                                color: black;
                                &:before,
                                &:after {
                                    content: "";
                                    display: block;
                                    position: absolute;
                                    width: 10px;
                                    height: auto;
                                    transform: skew(-10deg);
                                    top: 0;
                                    bottom: 0;
                                    transition: transform 0.25s ease-in-out, background 0.25s ease-in-out;
                                    background: ${resolveColor("primary.main", theme)};
                                }
                                &:after {
                                    right: -5px;
                                }
                                &:before {
                                    left: -5px;
                                }
                            `,
                        ],
                        "min",
                    )}
            `,
        },
        linksContainerStyles: {
            css: css`
                display: flex;
                flex-direction: row;
                align-items: center;
                a {
                    p {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    null,
                                    css`
                                        color: ${resolveColor("secondary.main", theme)} !important;
                                    `,
                                ],
                                "max",
                            )}
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                background: #f9f9f9;
                                font-size: 14px;
                            `,
                        ],
                        "min",
                    )}
            `,
        },
        separatorIconProps: {
            size: 18,
            css: css`
                margin-right: 14px;
                margin-left: 12px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                display: none;
                            `,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: none;
                        `,
                        css`
                            margin-left: -15px;
                            margin-top: -11px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
};
/* Husky Custom Code - End */

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageBreadcrumbs = (props: Props) => {
    /* Husky Custom Code - Start */
    let links = props.links || generateLinksFrom(props.linksState, props.nodeId, props.homePageUrl);

    const styles = useMergeStyles("pageBreadcrumbs", pageBreadcrumbStyles, props.extendedStyles);

    const homePageLink = useMemo(
        () => ({
            children: translate("Home_Breadcrumb"),
            href: props.homePageUrl,
            icon: {
                iconProps: {
                    size: 18,
                    src: House,
                    css: css`
                        font-size: 14px;
                        &,
                        svg {
                            width: 20px;
                            height: 18px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            color: ${getColor("common.background")};
                                        `,
                                        null,
                                        css`
                                            color: ${resolveColor("secondary.main", theme)};
                                        `,
                                        null,
                                    ],
                                    "max",
                                )}
                        }

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        //display: none;
                                    `,
                                    null,
                                ],
                                "max",
                            )}
                    `,
                },
            },
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                p {
                                    display: none;
                                }
                            `,
                            null,
                            null,
                            css`
                                font-size: 14px;
                                margin-right: 10px;
                                position: relative;
                                background: ${resolveColor("common.accentContrast", theme)};
                                padding: 8px 10px 10px 20px;

                                // We only want margin for first link
                                + span + a {
                                    margin-left: 12px;
                                }

                                &,
                                &:after {
                                    transition: background 0.25s ease-in-out;
                                }

                                &:after {
                                    content: "";
                                    display: block;
                                    position: absolute;
                                    right: -5px;
                                    width: 10px;
                                    height: auto;
                                    transform: skew(-10deg);
                                    top: 0;
                                    bottom: 0;
                                    background: ${resolveColor("common.accentContrast", theme)};
                                }

                                &:hover,
                                &:hover:after {
                                    background-color: ${safeColor(resolveColor("common.accentContrast", theme))
                                        .darken(0.15)
                                        .string()};
                                }
                                &,
                                &:active,
                                &:focus,
                                &:visited,
                                &:hover {
                                    svg {
                                        color: white;
                                    }
                                }
                            `,
                        ],
                        "min",
                    )}
            `,
        }),
        [props.homePageUrl],
    );

    if (links.length > 0) {
        const linksWithoutHomePageLink = [...links].splice(1, links.length);
        links = [homePageLink, ...linksWithoutHomePageLink];
    }

    const styledLinks: LinkProps[] = links.map((link: any) => {
        return {
            color: "danger.main",
            ...link,
        };
    });

    return (
        <Breadcrumbs links={styledLinks} data-test-selector="pageBreadcrumbs" {...pageBreadcrumbStyles.breadcrumbs} />
    );
    /* Husky Custom Code - End */
};

export function generateLinksFrom(linksState: LinksState, nodeId: string, homePageUrl: string) {
    const links: LinkProps[] = [];
    let currentLink = getPageLinkByNodeId({ links: linksState }, nodeId);
    const vmiPageTypes: string[] = [
        "VmiDashboardPage",
        "VmiLocationsPage",
        "VmiLocationDetailsPage",
        "VmiBinsPage",
        "VmiBinDetailsPage",
        "VmiReportingPage",
        "VmiUsersPage",
        "VmiOrderHistoryPage",
        "VmiOrderDetailsPage",
    ];
    const vmiExcludePageTypes: string[] = ["HomePage", "MyAccountPage"];
    const search = (targetText: string) => (sourceTextArray: string) => sourceTextArray === targetText;
    const isVmiPageType = !currentLink?.type ? false : vmiPageTypes.some(search(currentLink.type));

    while (currentLink) {
        const isVmiExcludePageType = !currentLink?.type ? false : vmiExcludePageTypes.some(search(currentLink.type));
        if (!isVmiPageType || !isVmiExcludePageType) {
            links.unshift({
                children: currentLink.type === "HomePage" ? translate("Home_Breadcrumb") : currentLink.title,
                href: currentLink.url,
                type: currentLink.type,
            });
        }

        currentLink = currentLink.parentId
            ? getPageLinkByNodeId({ links: linksState }, currentLink.parentId)
            : undefined;
    }

    return links;
}

export default connect(mapStateToProps)(PageBreadcrumbs);
